var map = {
	"./de/btn-back.png": "ms34",
	"./en/btn-back.png": "DXWY",
	"./es/btn-back.png": "Rn+t",
	"./fr/btn-back.png": "Qqoa",
	"./ja/btn-back.png": "2bPN",
	"./ko/btn-back.png": "cFjb",
	"./pt/btn-back.png": "iwGg",
	"./ru/btn-back.png": "3Zu5",
	"./th/btn-back.png": "8wVK",
	"./zh-Hant/btn-back.png": "MHQe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+asl";